import React, { FC } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import { ClassesPageQueryQuery } from "@graphqlTypes"

import { getImgixImageData } from "@utils"

import Avatar from '@components/Avatar/Avatar'
import AvatarsRow from '@components/AvatarsRow/AvatarsRow'

import {
  ClassesPageHeroHERO,
  ClassesPageHeroContentDIV,
  ClassesPageHeroImageDIV,
  ClassesPageHeroAvatarsDIV,
} from './ClassesPageHero.styles'

type ClassesPageHeroProps = {
  avatars: ClassesPageQueryQuery["avatarsData"]["nodes"]
}

const ClassesPageHero: FC<ClassesPageHeroProps> = ({
  avatars,
}) => (
  <ClassesPageHeroHERO>
    <div className="container">
      <div className="grid">
        <div className="column column--1-8-M">
          <ClassesPageHeroContentDIV>
            <h1 className="font--display-L">Help&nbsp;Scout Classes</h1>
            <p className="type--text-L">Free training from the Help Scout team.</p>
            <ClassesPageHeroAvatarsDIV>
              <AvatarsRow>
                {[
                  "Alison Groves",
                  "Kristi Thompson",
                  "Christine Chavez",
                  "Liam Doherty",
                ].map(_name => {
                  const avatarToUse = avatars.find(({ name }) => name === _name)
                  if (!avatarToUse || !avatarToUse.image) return null
                  return <Avatar key={_name} name={_name} image={avatarToUse.image} />
                })}
              </AvatarsRow>
              <div className="font-family--mono color--text-dark font-size--S">Hosted by the Customers&nbsp;Team</div>
            </ClassesPageHeroAvatarsDIV>
          </ClassesPageHeroContentDIV>
        </div>
        <div className="column column--8-13-M">
          <ClassesPageHeroImageDIV>
            <GatsbyImage
              alt=""
              image={getImgixImageData(
                '/images/pages/classes/ClassesPage--hero--evo.png',
                632,
                1.56
              )}
              title="Help Scout Customer Champion showing off the inbox and Beacon"
            />
          </ClassesPageHeroImageDIV>
        </div>
      </div>
    </div>
  </ClassesPageHeroHERO>
)

export default ClassesPageHero